module.exports = __webpack_public_path__ + "static/img/225.19dde9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200608/225.jpg
// module id = g62x
// module chunks = 0